export default __webpack_public_path__ + "static/media/magic-video.0eefaa2f.svg";